module.exports = SongList;

//Abstract type; use DynamicSongList or StaticSongList rather than using this directly.
function SongList(listName) {
	this.name = listName || null;
	this.id = null;
	this.userId = null;
	//For instutitional subscriptions using IP recognition, we might not have a user ID
	//but we'll have a subscription ID.
	this.institutionalSubscriptionId = null;
	this.shared = false;
	
	//For lists shared by (not logged-in) institutional users - the email of the person who created the list
	this.creatorEmail = undefined;
	//security code to allow the creator (and potentially selected others) to edit the list
	this.editCode = undefined;
}

SongList.fromJson = function(json) {
	var DynamicSongList = require('./SongList/DynamicSongList'),
		StaticSongList = require('./SongList/StaticSongList');
	
	if (typeof json == 'string') {
		json = JSON.parse(json);
	}
	
	var list = (json._prototype == 'StaticSongList' ? new StaticSongList(): new DynamicSongList());
	var baseProps = ['id', 'name', 'userId', 'institutionalSubscriptionId', 'shared', 'creatorEmail', 'editCode', 'timeCreated'];
	baseProps.forEach(function(prop) {
		list[prop] = json[prop];
	});
	
    if (json._prototype == 'StaticSongList' && json.songIds) {
        list.setSongIds(json.songIds);
    }
    else {
		list.searchParams = json.searchParams;
		if (typeof json.queryParams == 'string') {
			list.queryParams = JSON.parse(json.queryParams);
		}
		else list.queryParams = json.queryParams;
    }
	
    return list;
};

SongList.prototype = {
	constructor: SongList

	//getSongsQueryParams - should be implemented by child classes
}